import { DeleteOutlined, EditOutlined } from '@ant-design/icons';
import { Spin } from 'antd';
import type { TableActionsButtonProps } from './TableActionsButton';
import { TableActionsInline } from './TableActionsInline';

export function getButtonsEditDelete({
    disabled,
    onEdit,
    onDelete,
}: {
    disabled: boolean;
    onEdit: () => void;
    onDelete: () => void;
}): TableActionsButtonProps[] {
    return [
        {
            disabled,
            icon: <EditOutlined />,
            id: 'editar',
            onClick: onEdit,
            type: 'primary',
        },
        {
            confirm: 'Tem certeza que deseja excluir?',
            danger: true,
            disabled,
            icon: <DeleteOutlined />,
            id: 'excluir',
            onClick: onDelete,
            type: 'primary',
        },
    ];
}

export function TableActionsEditDelete({
    loading = false,
    disabled = false,
    onEdit,
    onDelete,
}: {
    loading?: boolean;
    disabled?: boolean;
    onEdit: () => void;
    onDelete: () => void;
}) {
    const buttons = getButtonsEditDelete({ disabled, onDelete, onEdit });

    return (
        <Spin spinning={loading}>
            <TableActionsInline buttons={buttons} />
        </Spin>
    );
}
